import React, { useState, useEffect } from "react";
import axios from "axios";

const Staff = ({ handleToast, id,   closeLoading,
  handleLoading }) => {
  const [staff, setStaff] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [staffToDelete, setStaffToDelete] = useState(null);

  useEffect(() => {
    axios
      .get(`https://api.dectwinhotel.com/api/${id}_staff/get-staff`)
      .then((response) => {
        localStorage.setItem("rooms", JSON.stringify(response.data));
        setStaff(response.data);
      })
      .catch((error) => {
        if (error.code === "ECONNABORTED") {
          window.location.reload();
        }
        console.error("Error fetching staff:", error);
      });
  }, [id]);

  const renderPermissionIcon = (value) => (value ? "✔️" : "❌");

  // Handle delete ivoice
  const deleteInvoice = async () => {
    handleLoading();
    try {
      await axios.delete(
        `https://api.dectwinhotel.com/api/${id}_staff/delete-staff/${staffToDelete}`
      );
      closeLoading();
      handleToast({
        toastMsg: "Staff Deleted Successfully!!!",
        toastColor: "#4CAF50",
      });
  setStaff((prevStaff) => prevStaff.filter((s) => s.id !== staffToDelete));
    //   setFilteredReports([]);
    } catch (err) {
      handleToast({
        toastMsg: "Something went wrong! Please try again",
        toastColor: "#FF0000",
      });
      closeLoading();
    } finally {
      setShowConfirm(false);
      setStaffToDelete(null);
    }
  };

  const handleDelete = (id) => {
    setShowConfirm(true);
    setStaffToDelete(id);
  };

  return (
    <>
    <section style={{ backgroundColor: "#282c34", padding: "4rem 1rem" }}>
      <div className="reports-page">
        <h2>View Staff</h2>

        <div className="table-responsive">
          <table className="reports-table">
            <thead>
              <tr>
                <th>Staff ID/ Password</th>
                <th>Name/ Role</th>
                <th>Email</th>
                {/* <th>Role</th> */}
                {/* <th>Password</th> */}
                <th colSpan={7}>Permissions</th>
                <th>Created On</th>
                <th>Activity</th>
              </tr>
              <tr>
                <th colSpan={3}></th>
                <th>Room</th>
                <th>Food</th>
                <th>Report</th>
                <th>Edit Invoice</th>
                <th>Purchase</th>
                <th>Settlement</th>
                <th>Due</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
<tbody>
  {staff.length === 0 ? (
    <tr>
      <td colSpan={11} style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
        No staff added yet.
      </td>
    </tr>
  ) : (
    staff.map((myStaff) => {
      const permissions = myStaff.permissions
        ? JSON.parse(myStaff.permissions)
        : {};

      return (
        <tr key={myStaff.id}>
          <td>{myStaff.staff_id}<br />Pass: {myStaff.password}</td>
          <td>{myStaff.name} ({myStaff.role})</td>
          <td>{myStaff.email}</td>
          {/* <td></td> */}
          {/* <td>{myStaff.password}</td> */}
          <td>{renderPermissionIcon(permissions.room)}</td>
          <td>{renderPermissionIcon(permissions.food)}</td>
          <td>{renderPermissionIcon(permissions.report)}</td>
          <td>{renderPermissionIcon(permissions.edit)}</td>
          <td>{renderPermissionIcon(permissions.purchase)}</td>
          <td>{renderPermissionIcon(permissions.settlement)}</td>
          <td>{renderPermissionIcon(permissions.due)}</td>
          <td>{myStaff.created_at}</td>
          <td
            className="text-black text-center"
            onClick={() => {
              handleDelete(myStaff.id);
            }}
            style={{ cursor: "pointer" }}
          >
            <i title="Remove Staff" className="fa fa-trash"></i>
          </td>
        </tr>
      );
    })
  )}
</tbody>
          </table>
        </div>
      </div>
    </section>
      {showConfirm && (
        <div className="modal">
          <div style={{ textAlign: "center" }} className="modal-content">
            <p>Are you sure you want to remove this invoice?</p>
            <div className="d-flex justify-content-center">
              <button onClick={deleteInvoice}>Yes</button>
              &nbsp;&nbsp;&nbsp;
              <button onClick={() => setShowConfirm(false)}>No</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Staff;
